/**
 * F5 - a sidebar recolhida no desktop e preferencia de quem olha (este
 * navegador), nao do workspace. Sem armazenamento (aba privada, bloqueio),
 * abre expandida e a escolha vale so nesta visita.
 */
export const CHAVE_SIDEBAR = 'shell.sidebar.recolhida';

type Armazenamento = Pick<Storage, 'getItem' | 'setItem'>;
const doNavegador = (): Armazenamento | undefined => globalThis.localStorage;

export function sidebarRecolhida(
  armazenamento: () => Armazenamento | undefined = doNavegador,
): boolean {
  try {
    return armazenamento()?.getItem(CHAVE_SIDEBAR) === '1';
  } catch {
    return false;
  }
}

export function guardarSidebarRecolhida(
  recolhida: boolean, armazenamento: () => Armazenamento | undefined = doNavegador,
): void {
  try {
    armazenamento()?.setItem(CHAVE_SIDEBAR, recolhida ? '1' : '0');
  } catch { /* sem armazenamento: vale so nesta visita */ }
}
